import {
  RESET_PASSWORD,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_SUCCESS,
} from './types';

export function resetGoBizPassword(email) {
  return {
    type: RESET_PASSWORD,
    payload: {
      email,
    },
  };
}

export function resetGoBizPasswordSuccess() {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: {},
  };
}

export function resetGoBizPasswordFailure(error) {
  return {
    type: RESET_PASSWORD_FAILURE,
    error,
    payload: {
      error,
    },
  };
}
